import React, { useEffect, useState } from "react";
import { api } from "../../api";
import { useLanguage } from "../../i18n";

// Checked once when Home loads (see GET /api/properties/photo-nudge) instead
// of arriving as a push/bell notification — an owner who's actively in the
// app is far more likely to act on a popup asking them to add photos right
// now than on a notification-list item they may never open.
export function PhotoNudgePopup({ onAddPhotos }: { onAddPhotos: (propertyId: string) => void }) {
  const { t } = useLanguage();
  const [property, setProperty] = useState<{ id: string; label: string } | null>(null);

  useEffect(() => {
    api
      .get("/api/properties/photo-nudge")
      .then(({ property }) => setProperty(property))
      .catch(() => {});
  }, []);

  async function dismiss() {
    if (!property) return;
    const id = property.id;
    setProperty(null);
    await api.post(`/api/properties/${id}/photo-nudge/seen`, {}).catch(() => {});
  }

  async function addPhotos() {
    if (!property) return;
    const id = property.id;
    setProperty(null);
    await api.post(`/api/properties/${id}/photo-nudge/seen`, {}).catch(() => {});
    onAddPhotos(id);
  }

  if (!property) return null;

  return (
    <>
      <div className="filter-backdrop" onClick={dismiss} />
      <div className="filter-sheet" style={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
        <div className="filter-sheet-handle" />
        <div className="boost-sheet-icon">📷</div>
        <div className="reg-title" style={{ marginBottom: 2 }}>{t("photoNudge.title")}</div>
        <div className="sub" style={{ marginBottom: 16 }}>{t("photoNudge.body", { property: property.label })}</div>
        <button className="btn-solid" onClick={addPhotos}>
          {t("photoNudge.addPhotosButton")}
        </button>
        <button className="link-btn" style={{ marginTop: 10 }} onClick={dismiss}>
          {t("photoNudge.remindLaterButton")}
        </button>
      </div>
    </>
  );
}
